import React from "react";
var __jsx = React.createElement;
import { t } from "i18next";
function ModalFooter(_ref) {
  var selectedCount = _ref.selectedCount,
    onCancel = _ref.onCancel,
    onLink = _ref.onLink,
    isLinkDisabled = _ref.isLinkDisabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-5 py-4 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 rounded-b-12"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-base text-gray-500"
  }, t("label.files-selected", {
    count: selectedCount
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onCancel,
    className: "h-[32px] w-[109px] rounded-8 text-base font-medium text-teal-400 bg-teal-300/[0.16] hover:bg-teal-300/[0.24] transition-colors"
  }, t("button.cancel")), /*#__PURE__*/React.createElement("button", {
    onClick: onLink,
    className: "h-[32px] w-[109px] rounded-8 text-base font-medium text-gray-100 dark:text-gray-900 bg-teal-400 hover:bg-teal-400 transition-colors disabled:opacity-30 disabled:cursor-not-allowed",
    disabled: isLinkDisabled
  }, t("link"))));
}
export default ModalFooter;